module.exports = __webpack_public_path__ + "img/banner.d5cfe3e7.png";